module.exports = __webpack_public_path__ + "media/images/icons/calendar-white-78ca40d70ea34b4c622af2d8c7c9d30f.svg";